import React, { useState, useEffect } from 'react';
import {
  Route,
  Routes,
  BrowserRouter,
  Navigate,
  useParams,
} from 'react-router-dom';
import { useDispatch } from 'react-redux';
import CssBaseline from '@mui/material/CssBaseline';
import Home from 'components/Home';
import Document from 'components/Document';
import Instructions from 'components/Instructions';
import FeedbackForm from 'components/FeedbackForm';
import ErrorBar from 'components/ErrorBar';
import Section from 'components/Section';
import SiteHeader from 'components/SiteHeader';
import Footer from 'components/Footer';
import PrivacyPolicy from 'components/PrivacyPolicy';
import Accessibility from 'components/Accessibility';
import SiteInfo from 'components/SiteInfo';
import ForResearcher from 'components/ForResearcher';
import Referencing from 'components/Referencing';
import Dictionary from 'components/Dictionary';
import Hakuvahti from 'components/Hakuvahti';
import { getFacetConstants } from 'actions/facetConstantsActions';
import { reportError } from 'actions/errorActions';
import { changeLanguage } from 'actions/langActions';
import { changeSearchState } from 'actions/searchStateActions';

function LausuntokierrosRedirect() {
  const { doc_id } = useParams();
  return (
    <Navigate
      to={`/asiakirjat/lausuntokierros-asiakirjat/${doc_id}`}
      replace
    />
  );
}

const getParamsValue = (propertyName, defaultValue) => {
  const params = new URLSearchParams(
    window.location.search,
  );
  const value = params.get(propertyName);
  if (!value) return defaultValue;
  else return value;
};

const App = () => {
  const dispatch = useDispatch();

  const [constantsLoaded, setConstantsLoaded] =
    useState(false);

  useEffect(() => {
    /* eslint-disable no-lone-blocks*/ /* prettier-ignore*/ {
    // Matomo Tag manager:
    var _mtm = window._mtm = window._mtm || [];
    _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
    var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
    g.async=true; 
    g.src='https://mtm.utu.fi/js/container_IEjyxHoY.js'; 
    if (s){
      s.parentNode.insertBefore(g,s);
    }}

    // functions to help prevent focus ring when using mouse
    document.body.addEventListener('mousedown', () => {
      document.body.classList.add('using-mouse');
    });
    document.body.addEventListener('keydown', () => {
      document.body.classList.remove('using-mouse');
    });

    const lang = getParamsValue('lang', 'fi');
    dispatch(changeLanguage(lang));

    const status = getParamsValue('status', 'yleinen');
    dispatch(changeSearchState(status));

    // fetch facetConstants to Redux
    const fetchConstants = async () => {
      try {
        await dispatch(getFacetConstants());
        setConstantsLoaded(true);
      } catch (err) {
        dispatch(reportError(err));
        setConstantsLoaded(true);
      }
    };
    fetchConstants();
  }, [dispatch]);

  return (
    <div className="App" data-testid="app">
      <CssBaseline />

      {constantsLoaded && (
        /* to disable warnings about future changes,
        explicitly decline early opt-in
        https://reactrouter.com/6.30.3/upgrading/future */
        <BrowserRouter
          future={{
            v7_relativeSplatPath: false,
            v7_startTransition: false,
          }}
        >
          <Section
            className="section--header"
            role="banner"
          ></Section>
          <SiteHeader />
          <Routes>
            <Route exact path="/" Component={Home} />
            <Route
              path="/haku/:docGroup"
              Component={Home}
            />
            {/* Navigate for legacy link support */}

            {/* <Route path="*" element={
              <Navigate
                from="/asiakirjat/lausuntokierros-lausunnot/:doc_id"
                to="/asiakirjat/lausuntokierros-asiakirjat/:doc_id"
              />
              }
            /> */}
            <Route
              path="asiakirjat/lausuntokierros-lausunnot/:doc_id"
              element={<LausuntokierrosRedirect />}
            />
            {/* <Route path="*" element={
              <Navigate
                from="/asiakirjat/lausuntokierros-muut/:doc_id"
                to="/asiakirjat/lausuntokierros-asiakirjat/:doc_id"
              />
              }
            /> */}
            <Route
              path="/asiakirjat/lausuntokierros-muut/:doc_id"
              element={<LausuntokierrosRedirect />}
            />
            <Route
              path="/asiakirjat/:doc_group/:doc_id"
              Component={Document}
            />
            <Route
              path="/ohjeet"
              Component={Instructions}
            />
            <Route
              path="/palaute"
              Component={FeedbackForm}
            />
            <Route
              path="/tietosuoja"
              Component={PrivacyPolicy}
            />
            <Route
              path="/saavutettavuus"
              Component={Accessibility}
            />
            <Route
              path="/hakuvahti"
              Component={Hakuvahti}
            />
            <Route path="/tietoja" Component={SiteInfo} />
            <Route
              path="/tutkijalle"
              Component={ForResearcher}
            />
            <Route
              path="/viittaaminen"
              Component={Referencing}
            />
            <Route
              path="/dictionary"
              Component={Dictionary}
            />
          </Routes>
          <Footer />
        </BrowserRouter>
      )}

      <ErrorBar />
    </div>
  );
};

export default App;
